<template>
  <div>
    <div v-if="$store.state.darkMode">
      <button
        v-on:click="goBack"
        class="backButtonTop"
        aria-label="Back to Previous Question"
      >
        <svg
          viewBox="0 0 18 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="inline-block h-3 pt-0"
        >
          <path
            d="M6.80942 14.625C7.04069 14.8625 7.36189 15 7.72163 15C8.42827 15 9.00642 14.4375 9.00642 13.75C9.00642 13.4 8.8651 13.0875 8.63383 12.8625L4.40685 8.75L16.7152 8.75C17.4218 8.75 18 8.1875 18 7.5C18 6.8125 17.4218 6.25 16.7152 6.25L4.394 6.25L8.62099 2.1375C8.85225 1.9125 8.99358 1.6 8.99358 1.25C8.99358 0.5625 8.41542 0 7.70878 0C7.34904 0 7.02784 0.137499 6.79657 0.362499L0.372591 6.6125C0.141328 6.8375 0 7.15 0 7.5C0 7.85 0.154176 8.15 0.385439 8.375L6.80942 14.625Z"
            fill="#e6e6e6"
          />
        </svg>
        <span class="font-medium text-purple-600 inline-block text-lg hidden"
          >&nbsp; Back</span
        >
      </button>
    </div>

    <div v-else>
      <button
        v-on:click="goBack"
        class="backButtonTop"
        aria-label="Back to Previous Question"
      >
        <svg
          viewBox="0 0 18 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="inline-block h-3 pt-0"
        >
          <path
            d="M6.80942 14.625C7.04069 14.8625 7.36189 15 7.72163 15C8.42827 15 9.00642 14.4375 9.00642 13.75C9.00642 13.4 8.8651 13.0875 8.63383 12.8625L4.40685 8.75L16.7152 8.75C17.4218 8.75 18 8.1875 18 7.5C18 6.8125 17.4218 6.25 16.7152 6.25L4.394 6.25L8.62099 2.1375C8.85225 1.9125 8.99358 1.6 8.99358 1.25C8.99358 0.5625 8.41542 0 7.70878 0C7.34904 0 7.02784 0.137499 6.79657 0.362499L0.372591 6.6125C0.141328 6.8375 0 7.15 0 7.5C0 7.85 0.154176 8.15 0.385439 8.375L6.80942 14.625Z"
            fill="#8380A8"
          />
        </svg>
        <span class="font-medium text-purple-600 inline-block text-lg hidden"
          >&nbsp; Back</span
        >
      </button>
    </div>
  </div>
</template>

<script>
import store from "../store";
export default {
  name: "BackButton",
  data: function () {
    return {};
  },
  methods: {
    goBack() {
      this.scrollToTop();
      store.commit("findActiveQuestion");
    },
    scrollToTop: function () {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
  },
};
</script>

<style></style>
